
import { Component, Vue } from 'vue-property-decorator';

/**
 * The website's key figures from PostHog (docs/analytics.md), next to the older tabs.
 * VUE_APP_POSTHOG_DASHBOARD_URL is the dashboard's public share link (…/shared/<token>);
 * the embed is the same link under /embedded/.
 */
@Component
export default class PostHogDashboard extends Vue {
  shareUrl = (process.env.VUE_APP_POSTHOG_DASHBOARD_URL || '').trim();

  get embedUrl(): string {
    return this.shareUrl.replace('/shared/', '/embedded/');
  }
}
